import { NotificationType } from '@services/model/notify';

export const initialState: Array<NotificationType> = [];
